import React from "react";
import { useFormContext } from "react-hook-form";
import { Dialog, Form } from "@sscs/ui";
import { PURL_SAFE_HELP_MESSAGE } from "Constants";
import { ProjectFormData } from "Types";
import { getCleanValue } from "Utils";

type ProjectProps = {
  catalogName: string;
  projects: string[];
};

const Project = ({
  catalogName,
  projects,
}: ProjectProps): React.JSX.Element => {
  const { formState, setValue, watch } = useFormContext<ProjectFormData>();
  const projectName = getCleanValue(watch("project_name") ?? "");
  const isNewProject = projectName !== "" && !projects.includes(projectName);

  return (
    <Dialog.Section>
      <Dialog.Section.Title>Choose project</Dialog.Section.Title>
      <Dialog.Section.Description>
        The project name is suggested by the {catalogName} catalog. Keep it to
        create a new project or pick an existing one.
      </Dialog.Section.Description>
      <Dialog.Section.Content>
        <Form.Autocomplete
          id="project-autocomplete"
          name="project_name"
          label="Project name"
          options={projects}
          freeSolo
          onInputChange={(_event, value) => setValue("project_name", value)}
          errors={formState.errors}
          placeholder="Search projects"
          helperText={
            isNewProject
              ? `This project does not exist yet and will be created on import. ${PURL_SAFE_HELP_MESSAGE}`
              : "The software will be imported to this existing project."
          }
        />
        {isNewProject && (
          <Form.TextArea
            name="project_description"
            label="Short description"
            id="project-description"
            errors={formState.errors}
          />
        )}
      </Dialog.Section.Content>
    </Dialog.Section>
  );
};

export default Project;
